<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 style="max-width:400px;margin-left:auto;margin-right:auto">
          <img
            src="@/assets/logo.png"
            alt="Vuetify.js"
            class="mb-5"
            style="width:100%"
          />
          <v-card-text>
            <v-form v-on:submit="login">
              <v-text-field prepend-icon="person" name="login" label="Login" type="text" v-model="details.email" :rules="emailRules" v-on:keyup="checkKey"></v-text-field>
              <v-text-field id="password" prepend-icon="lock" name="password" label="Password" type="password" v-model="details.password" v-on:keyup="checkKey"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="login()">Login</v-btn>
          </v-card-actions>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showError">
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
          style="max-height: 50px;"
        >
          Login Error
        </v-card-title>
        <v-card-text>
          Please check your username and password.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions
          style="max-height: 50px;"
        >
          <v-btn flat color="primary" @click="showError = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    computed: {
      ...mapGetters(["user", "loginError"])
    },
    data () {
      return {
        showLogin: true,
        showError: false,
        details: {
          email: undefined,
          password: undefined
        },
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
      };
    },
    watch: {
      loginError(val) {
        if (val) {
          this.showError = true;
        }
      }
    },
    methods: {
      checkKey (e) {
        if (e.keyCode === 13) {
          this.login();
        }
      },
      login () {
        this.$store.dispatch("login", {
          email: this.details.email,
          password: this.details.password
        });
      }
    }
  }
</script>

<style scoped>
</style>
